import { jsx as _jsx } from "react/jsx-runtime";
import { get } from 'lodash';
import { styled } from 'styled-components';
import { Button } from "../../../button/src";
import { CATEGORIES, FontAwesomeIcon } from "../../../font-awesome-icon/src";
import { primaryShadow } from "../../../theme/src";
export const Control = ({ breakpoint, currentSlide, infinite, isPrev, itemsCount, loading, navTopPosition, nextSlide, perPage, previousSlide, total, }) => {
    var _a, _b;
    const totalItems = total !== null && total !== void 0 ? total : itemsCount;
    const pickDir = (forPrev, forNext) => isPrev ? forPrev : forNext;
    const ariaLabelPrevPage = ((_a = window === null || window === void 0 ? void 0 : window.s__) === null || _a === void 0 ? void 0 : _a.call(window, 'Accessibility|Display previous results')) ||
        'Display previous results';
    const ariaLabelNextPage = ((_b = window === null || window === void 0 ? void 0 : window.s__) === null || _b === void 0 ? void 0 : _b.call(window, 'Accessibility|Display next results')) ||
        'Display next results';
    const ariaLabel = pickDir(ariaLabelPrevPage, ariaLabelNextPage);
    const dataTestId = pickDir('slider-arrow-previous', 'slider-arrow-next');
    const isEdge = pickDir(currentSlide === 0 && !infinite, currentSlide + perPage >= itemsCount + Number(loading) && !infinite);
    const isDisabled = pickDir(false, isEdge);
    const isHidden = pickDir(isEdge, totalItems % perPage > 0 &&
        currentSlide >= totalItems - perPage + 1 &&
        !infinite);
    const onClick = pickDir(previousSlide, nextSlide);
    return isHidden ? null : (_jsx(StyledButton, { "$breakpoint": breakpoint, "$isPrev": isPrev, "$navTopPosition": navTopPosition, "aria-label": ariaLabel, dataTestId: dataTestId, icon: () => (_jsx(FontAwesomeIcon, { iconName: isPrev ? 'angle-left' : 'angle-right', iconType: CATEGORIES.REGULAR })), isDisabled: isDisabled, onClick: onClick, variant: "inversed" }));
};
const StyledButton = styled(Button).attrs(({ $isPrev }) => ({
    ml: $isPrev ? -4 : undefined,
    mr: $isPrev ? undefined : -4,
})) `
  ${primaryShadow}
  border-radius: 20px !important;
  height: 40px;
  pointer-events: auto;
  top: ${({ $breakpoint, $navTopPosition }) => get($navTopPosition, $breakpoint, $navTopPosition)};
  width: 40px;
  ${({ $isPrev }) => ($isPrev ? 'left: 0;' : 'right: 0;')}
  ${({ $navTopPosition }) => $navTopPosition ? 'position: absolute;' : undefined}
`;
//# sourceMappingURL=Control.js.map